import React, {ReactNode} from 'react';
import styles from './CLTooltip.module.scss';
import CLOverlayTrigger, {CLOverlayTriggerProps, PopperType} from '../../CLOverlayTrigger';
import classNames from 'classnames';
import useDimensions from '../../../../hooks/useDimensions';

const TOOLTIP_OFFSET_CONTENT = 8;

const defaultTooltipOffset: [number, number] = [0, TOOLTIP_OFFSET_CONTENT];

export type CLTooltipProps = Omit<CLOverlayTriggerProps, 'type' | 'trigger' | 'popperOffset'> & {
  inlineBlock?: boolean;
  popperOffset?: [number, number];
};

function CLTooltip({
  children,
  inlineBlock,
  triggerClassName,
  popperOffset = [...defaultTooltipOffset],
  ...props
}: CLTooltipProps) {
  return (
    <CLOverlayTrigger
      type={PopperType.Tooltip}
      trigger="hover"
      popperOffset={{
        name: 'offset',
        options: {
          offset: popperOffset,
        },
      }}
      triggerClassName={classNames(triggerClassName, {[styles.inline_block]: inlineBlock})}
      {...props}
    >
      {children}
    </CLOverlayTrigger>
  );
}

CLTooltip.Titled = ({children, title}: {children: ReactNode; title: ReactNode}) => (
  <div className={styles.titled_container}>
    {!!title && <div className={styles.title}>{title}</div>}
    <div className={classNames(styles.description, styles.long)}>{children}</div>
  </div>
);

const Description = ({children}: {children: ReactNode}) => {
  const {elementRef, height} = useDimensions();
  const lineHeight = 17;
  const minRowsToLong = 3;

  return (
    <div
      className={classNames(styles.description, {
        [styles.long]: height > lineHeight * minRowsToLong,
      })}
      ref={elementRef}
    >
      {children}
    </div>
  );
};

CLTooltip.Description = Description;

CLTooltip.Subtitle = ({children, inline}: {children: ReactNode; inline?: boolean}) => (
  <div className={classNames(styles.subtitle, {[styles.inline]: inline})}>{children}</div>
);

export default CLTooltip;
